<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          ref="elSearch"
          width="460px"
          :formProp="formData"
          @search="search"
          :isShowSearch="true"
          class="ccui-highsearch no-print"
        >
          <template slot="search">
            <el-date-picker
              v-model="formData.updateTimeLess"
              searchLabel="发布时间"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
            <el-input
              v-model.trim="formData.noticeTitle"
              clearable
              searchLabel="标题"
              placeholder="请输入标题模糊查询"
            ></el-input>
          </template>
          <el-date-picker
            v-model="formData.updateTimeLess"
            searchLabel="发布时间"
            clearable
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            slot="searchItem1"
          >
          </el-date-picker>
          <el-input
            v-model.trim="formData.noticeTitle"
            clearable
            searchLabel="标题"
            placeholder="请输入标题模糊查询"
            slot="searchItem2"
          ></el-input>
        </el-search>
      </div>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row.noticeTitle }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import {
  qryWorkDynamicsList,
  searchPpBidNotice,
  selectNoticeList
} from "@/app/shop/api/shopping";
import { announcementPageSource } from "@/setting/setting";
// import moment from "moment";
import { setSessionItem, getSessionItem } from "@/basa/utils";

export default {
  name: "noticeViewAllList",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  props: {
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    source: {
      type: String,
      default: ""
    },
    activeName: {
      type: String,
      default: ""
    },
    interfaceType: {
      type: String,
      default: ""
    },
    activeIndex: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      formDataSearch: {},
      localSearchData: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth
          // checked: true
        },
        {
          label: "标题",
          prop: "noticeTitle",
          // width: 500,
          // checked: true,
          slot: "title"
        },
        {
          label: "发布时间",
          prop: "noticeStartTime",
          width: commonTableWidth.dateTimeWidth
          // checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      type: 0
    };
  },
  activated() {
    if (this.source == announcementPageSource.evaluationResults) {
      this.type = "100068ZBGG";
    }
    if (this.source == announcementPageSource.purchaseAnnouncement) {
      this.type = "100068ZBXX";
    }
    let searchFormObj = getSessionItem("pageNo", this.tableName);
    console.log(searchFormObj, "localSearchData");
    if (searchFormObj && searchFormObj.searchForm) {
      this.formDataSearch = { ...searchFormObj.searchForm };
      this.formData = { ...searchFormObj.searchForm };
      this.pageNo = searchFormObj.pageNo;
      this.pageSize = getSessionItem("pageSize", this.tableName) || 10;
      console.log(this.formDataSearch, this.formData, "listBaseTable");
    } else {
      this.formData = {};
      this.formDataSearch = {};
      this.pageNo = 1;
      this.pageSize = 10;
    }
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  methods: {
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.localSearchData = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList(obj) {
      // if (obj.pageNo) {
      //   this.pageNo = obj.pageNo;
      // }
      // if (obj.pageSize) {
      //   this.pageSize = obj.pageSize;
      // }
      // 分页操作列表
      // this.getNoticeList();
      console.log(this.formDataSearch, obj, "handleList");
      this.getNoticeList({ ...this.formDataSearch, ...obj });
    },
    getNoticeList(reqObj) {
      if (this.source === "0" || this.source === "-1") {
        let param = typeof reqObj == "object" ? reqObj : {};
        param = {
          area: "",
          title: this.formData.noticeTitle,
          author: "",
          publishedBy: "",
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          isShowPageLoading: true,
          type: this.$route.query.type
        };

        if (
          this.formData.updateTimeLess &&
          this.formData.updateTimeLess.length !== 0
        ) {
          param.updateTimeMore = this.formData.updateTimeLess[0];
          param.updateTimeLess = this.formData.updateTimeLess[1];
        }

        // Object.assign(param, this.formData);
        // this.$delete(param, "noticeTime");
        this.tableData = [];
        qryWorkDynamicsList(param).then(res => {
          if (res.data.code === "0") {
            res.data.data.rows.forEach(item => {
              this.tableData.push({
                noticeTitle: item.title,
                noticeStartTime: item.updateTime,
                id: item.id
              });
            });
            this.pageTotal = res.data.data.recordsTotal;
          }
        });
      } else if (
        this.source === "2" ||
        this.source === "3" ||
        this.source === "10" ||
        this.source === "11"
      ) {
        let searchNoticeValue = "";
        if (this.source === "2" || this.source === "10") {
          searchNoticeValue = "100068ZBXX";
        } else if (this.source === "3" || this.source === "11") {
          searchNoticeValue = "100068ZBGG";
        }
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          searchNoticeType: searchNoticeValue,
          isShowPageLoading: true
        };
        if (
          this.formDataSearch.updateTimeLess &&
          this.formDataSearch.updateTimeLess.length !== 0
        ) {
          this.formDataSearch.noticeTimeStart = this.formDataSearch.updateTimeLess[0].split(
            " "
          )[0];
          this.formDataSearch.noticeTimeEnd = this.formDataSearch.updateTimeLess[1].split(
            " "
          )[0];
        }
        Object.assign(params, this.formDataSearch);
        this.$delete(params, "updateTimeLess");
        searchPpBidNotice(params).then(res => {
          if (res.data.code === "0") {
            res.data.data.rows.forEach(item => {
              item.noticeStartTime = item.noticeStartTime.slice(0, -3);
            });
            this.tableData = res.data.data.rows;
            this.pageTotal = res.data.data.recordsTotal;
          }
        });
      } else if (
        this.source === "12" ||
        this.source === "13" ||
        this.source === "14" ||
        this.source === "15" ||
        this.source === "16" ||
        this.source === "17" ||
        this.source === "18" ||
        this.source === "19" ||
        this.source === "20"
      ) {
        let searchNoticeValue = "";
        if (this.source === "12") {
          searchNoticeValue = "100068JCCG";
        } else if (this.source === "13") {
          searchNoticeValue = "100068JCFA";
        } else if (this.source === "14") {
          searchNoticeValue = "100068JCKJXY";
        } else if (this.source === "15") {
          searchNoticeValue = "100068WZJCML";
        } else if (this.source === "16") {
          searchNoticeValue = "100068JCZJCYMD";
        } else if (this.source === "17") {
          searchNoticeValue = "100068CGGLZD";
        } else if (this.source === "18") {
          searchNoticeValue = "100068SFWB";
        } else if (this.source === "19") {
          searchNoticeValue = "100068NMQYXX";
        } else if (this.source === "20") {
          searchNoticeValue = "100068HJQK";
        }
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          searchNoticeType: searchNoticeValue,
          isShowPageLoading: true
        };
        selectNoticeList(params).then(res => {
          if (res.data.code === "0") {
            res.data.data.rows.forEach(item => {
              let time = [];
              item.noticeStartTime = item.noticeStartTime.slice(0, -3);
              console.log(time, "time");
            });
            this.tableData = res.data.data.rows;
            this.pageTotal = res.data.data.recordsTotal;
          }
        });
      }
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.localSearchData = JSON.parse(JSON.stringify(searchData));
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNo,
        searchForm: this.localSearchData
      });
      this.getNoticeList(this.formDataSearch);
    },
    //查看
    check(row) {
      //评标结果、采购公告
      this.$router.push({
        path: "/announcementDetail",
        query: {
          noticeId: row.noticeId,
          id: row.id,
          schemeId: row.schemeId,
          source: this.source,
          type: row.type,
          interfaceType: this.interfaceType,
          publishedBy: row.publishedBy || "",
          activeIndex: this.activeIndex
        }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style scoped></style>
